import { FC, Fragment } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import { Input } from 'app/components/Mui';

interface IFormData {
  summary: string;
  expectedOutcome: string;
}

const DetailsStepContent:FC = () => {
  const { t } = useTranslation();

  const { control } = useFormContext<IFormData>();

  return (
    <Fragment>
      <Controller
        control={control} name="summary"
        render={({ field }) => (
          <Input
            {...field}
            multiline
            minRows={2}
            maxRows={4}
            label={t('labels.summary')}
          />
        )}
      />
      <Controller
        control={control} name="expectedOutcome"
        render={({ field }) => (
          <Input
            {...field}
            multiline
            minRows={2}
            maxRows={4}
            label={t('labels.expectedOutcome')}
          />
        )}
      />
    </Fragment>
  );
};

export default DetailsStepContent;
